// extracted by mini-css-extract-plugin
export default {"penalBox":"Penal_penalBox__8QzTU","titlePenal":"Penal_titlePenal__hqvSv","textPenal":"Penal_textPenal__ehEIg"};